// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1QoKw","left":"StickyBox_left__3Ohfj","right":"StickyBox_right__2-aam"};